import React from "react";
import { MenuData } from "./types";

const MenuDataContext = React.createContext<MenuData | null>(null);

export { MenuDataContext };
